/**
 * @fileoverview POST handler for the "/integrations/direct/cdi/segments_config" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { integrationsDirectCdiSegmentsConfigCacheKeys } from "./constants";
import type { CdiSegmentsConfig } from "./types";

export const postCdiSegmentsConfig = reactQueryMutationAdapter(
  integrationsDirectCdiSegmentsConfigCacheKeys,
  (params: CdiSegmentsConfig): Promise<CdiSegmentsConfig> => {
    return fetch(
      "/integrations/direct/cdi/segments_config",
      "POST",
      params,
      {},
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
